import { render, staticRenderFns } from "./TilteParallax.vue?vue&type=template&id=b443968c&scoped=true&"
import script from "./TilteParallax.vue?vue&type=script&lang=js&"
export * from "./TilteParallax.vue?vue&type=script&lang=js&"
import style0 from "./TilteParallax.vue?vue&type=style&index=0&id=b443968c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b443968c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VParallax,VRow})
